module.exports = __webpack_public_path__ + "static/assets/2001551c7cc77426db3bb692d9bb3c7a.png";